import React, { useState, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import cn from 'classnames';
import Lottie from 'react-lottie-player';

import animationData from 'Shared/spiner_blue.json';
import logoPrint from '../../assets/print.svg';
import logoShare from '../../assets/share.svg';
import logoDownload from '../../assets/download.svg';
import LeftPart from './components/LeftPart';
import RightPart from './components/RightPart';
import SendEmailModal from './components/SendEmailModal';
import Icon from 'Components/Icon/Icon';

import queryGetInvoiceDetails from './query';
import withErrorBoundary from 'Components/ErrorBoundary/ErrorBoundary';
import { logger } from 'RootShared/utility/ErrorLogger';

const TabInvoiceDetail = () => {
  const history = useHistory();
  const { id } = useParams();
  const [open, setOpen] = useState(false);

  const { data, loading, error } = useQuery(queryGetInvoiceDetails, {
    variables: {
      pk: +id,
    },
  });

  const handleOpenModal = useCallback(
    (e, closeByPressBg) => {
      if (closeByPressBg && e.target.className === 'modal-bg') {
        setOpen(false);
      } else if (!closeByPressBg) {
        setOpen(!open);
      }
    },
    [open]
  );

  if (error) {
    logger.error(error);
    toast(error.message, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      closeButton: true,
      hideProgressBar: false,
    });
  }

  return (
    <div className="container tab-invoice-detail" data-testid="tab-invoice-detail">
      {loading && (
        <Lottie
          data-testid="tab_invoice_detail"
          className="lottie"
          loop={true}
          play={true}
          animationData={animationData}
          width={100}
          style={{ width: 100, height: 100, margin: '0px auto' }}
        />
      )}
      {data && (
        <div data-testid="tab-invoice-detail-data">
          <div className="tab-navigation-header">
            <div className="tab-navigation-header__wrapper" onClick={history.goBack} data-testid="details-back-button">
              <Icon name="icon-left" className="tab-navigation-header__icon-left" />
              <span>BACK TO LIST</span>
            </div>
          </div>
          <div
            className={cn('tab-group-control-header', { 'tab-group-control-header__flex-end': !data.invoice.pdfUrl })}
          >
            <div className="twice-btn" onClick={handleOpenModal} data-testid="twice-btn">
              <div className="twice-btn__btn btn btn-contained">
                <img src={logoShare} alt="share" />
              </div>
              <div className="twice-btn__btn btn btn-outlined">Send</div>
            </div>
            {data.invoice.pdfUrl && (
              <>
                <a download href={data.invoice.pdfUrl}>
                  <div className="btn btn-outlined">
                    <img src={logoDownload} width="20" alt="download" />
                  </div>
                </a>
                <a href={data.invoice.pdfUrl} target="_blank" rel="noopener noreferrer">
                  <div className="btn btn-outlined">
                    <img src={logoPrint} alt="print" />
                  </div>
                </a>
              </>
            )}
          </div>
          <div className="tab-invoice-detail__wrapper">
            <LeftPart data={data.invoice} />
            <RightPart data={data.invoice} />
          </div>
          {open && <SendEmailModal pk={id} handleOpenModal={handleOpenModal} />}
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(TabInvoiceDetail);
